import * as Yup from "yup"

export const roleValidationSchema = Yup.object().shape({
  name: Yup.string().required("Namn är obligatoriskt").max(150, "Namn får max vara 150 tecken långt")
})
